import $ from 'jquery'
import 'datepicker'

import 'datepicker-es'
import 'datepicker-ca'
import 'jquery-ui.css'
import 'datepicker.css'

export default function datepicker(elem) {
  $(elem).
    datepicker($.extend($.datepicker.regional[lang], { dateFormat: 'dd/mm/yy' })).
    datepicker({
      showAnim: 'fadeIn',
      duration: 'fast',
      yearRange: 'c-20:c+30',
    })
}
